import { useMemo } from "react";

const useBackendUrl = () => {
  const backendUrl = useMemo(() => {
    // Check if running in the browser
    if (typeof window !== "undefined" || typeof document !== "undefined") {
      const hostname = window.location.hostname;

      if (hostname === "localhost") {
        return "http://localhost:3001/api"; // Local backend URL
      } else if (
        hostname === "dev-ael-auktion.vercel.app" ||
        hostname === "dev-ael-next-frontend.vercel.app"
      ) {
        return "https://ael-backend-development-402643550069.europe-west3.run.app/api"; // Dev backend URL for specific hosts
      } else if (hostname === "ael-auktion-staging.vercel.app") {
        return "https://ael-backend-staging-402643550069.europe-west3.run.app/api"; // Staging backend URL
      } else {
        return "https://ael-backend-main-402643550069.europe-west3.run.app/api"; // Production backend URL
      }
    }

    // Default to production backend URL during SSR
    return "https://ael-backend-main-402643550069.europe-west3.run.app/api";
  }, []);

  return backendUrl;
};

export default useBackendUrl;
